import React, {useState, useEffect} from 'react';
import { useParams } from "react-router-dom";
import BannerImg from '../assets/images/banner-img.svg';
import { useSelector, useDispatch } from 'react-redux';
import {shortNameUser, formatPostDate, TopicListData, callPageRenderTracking, loadingSection } from './common/Helper';

const Search = () => {
    
    var currentItems, updatedList;

    let { text } = useParams();
    const [searchedItems, setSearchedItems] =  useState([]);

    /****Get Data from storage*****/
    const topicBucketState =  useSelector(state => state.TopicBucket);
    const questionsArray = topicBucketState.bucket.owner_question ?? "";
   
    // console.log(text);
    // console.log(questionsArray);
    useEffect(() => {

           callPageRenderTracking({page_title:'Search',page_link:window.location.href});

          /*******add class on body*****/
          document.body.classList.add('white-bg-header', 'show-search-box');
          return () => {
            document.body.classList.remove('white-bg-header', 'show-search-box');
          }
  
    },[]);

    /*******If Questions have data*******/
    if(questionsArray.length>0){
        updatedList = questionsArray.filter(function(item){
            var post_title = item.post_title;
            return post_title.toLowerCase().search(
                text.toLowerCase()) !== -1;
        });
    }

    return (
        <div className='fullpage-box knowledge-fullpage-box topic-content-box p-l-0 p-r-0'>
    
        {/* Banner start */}
        <div className='topic-banner'>
        <div className="topic-container">
        <div className='inner-container'>
          <h1 className='topic-banner-title'>Search</h1>
          <p>Discuss, Connect and Collaborate: Ask your queries and get answers from the experts</p>
          <div className='banner-image'><img src={BannerImg} alt="" /></div>
        </div>
        </div>
        </div>
        {/* Banner End */}
    
    
        <div className="topic-container topic-list-container">
    
            <div className='topic-list-box'>
    
            {/********loading section*******/}
            {/* {topicBucketState.datatrack == 1 && loadingSection} */}
    
            {updatedList && <>
                {TopicListData(updatedList)}
            </>  }
    
            </div>
        
    
        </div>
        </div>
      )
}

export default Search;
